import { Tabs } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { StickyContainer, Sticky } from 'react-sticky';
import useQuery from '../../../../util/useQuery';
import Tab1 from './Tab1';
import Tab2 from './Tab2';
import Tab3 from './Tab3';
import Tab4 from './Tab4';
import Tab5 from './Tab5';
import Tab6 from '../RopaDetailView/Tab5';
import { ROUTER } from '../../../../constants/router';
import { useTranslation } from 'react-i18next';
import UserService from '../../../../services/UserService';

const { TabPane } = Tabs;

const renderTabBar = (props, DefaultTabBar) => (
    <Sticky bottomOffset={80}>
        {({ style }) => (
            <DefaultTabBar
                {...props}
                className="bg-white z-50"
                style={{ ...style }}
            />
        )}
    </Sticky>
);

export default function TabsDetail({ detail, editMode ,getRopaDetail, openTabDB, storageLocation}) {
    const { t } = useTranslation()
    const navigate = useNavigate();
    const { activityId } = useParams();
    const params = useQuery();
    const currentPackage = UserService.currentPackage();
    return (
        <div className="bg-white rounded-xl p-4 py-6 my-4 col-span-2">
            <StickyContainer>
                <Tabs
                    onChange={(key) =>
                        navigate(`${ROUTER.DS_INVENTORY.ROPA}/${activityId}?tab=${key}`)
                    }
                    activeKey={params.get('tab') || '1'}
                    renderTabBar={renderTabBar}
                >
                    <TabPane tab={t('RoPA.DataCollection')} key={1}>
                        <Tab1
                            collectData={detail?.collectData}
                            editMode={editMode}
                            getRopaDetail={getRopaDetail}
                        />
                    </TabPane>
                    <TabPane tab={t('RoPA.TypeOfPersonalData')} key={2}>
                        <Tab2
                            categoryPersonalData={detail?.categoryPersonalData}
                            editMode={editMode}
                            getRopaDetail={getRopaDetail}
                        />
                    </TabPane>
                    <TabPane tab={t('RoPA.Reference')} key={3}>
                        <Tab3
                            referenceDocuments={detail?.referenceDocuments}
                            editMode={editMode}
                            getRopaDetail={getRopaDetail}
                        />
                    </TabPane>
                    <TabPane tab={t('RoPA.StorageAndDestruction')} key={4}>
                        <Tab4
                            collectDataDestruction={
                                detail?.collectDataDestruction
                            }
                            editMode={editMode}
                            getRopaDetail={getRopaDetail}
                            storageLocation={storageLocation}
                        />
                    </TabPane>
                    {openTabDB && currentPackage === 4 && (
                        <TabPane tab={t('RoPA.Database')} key={6} >
                        </TabPane>
                    )}
                    <TabPane tab={t('RoPA.DataController')} key={5}>
                    </TabPane>
                </Tabs>
            </StickyContainer>
        </div>
    );
}
